import { render, staticRenderFns } from "./CafeCategory.vue?vue&type=template&id=24398b1b&scoped=true"
import script from "./CafeCategory.vue?vue&type=script&lang=js"
export * from "./CafeCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24398b1b",
  null
  
)

export default component.exports